import { Link } from "react-router-dom";

export default function ReturnsTeaser() {
  return (
    <section className="hairline py-16 rise" data-testid="returns-teaser">
      <span className="t-label">AI venture returns, 2024 to 2026</span>
      <Link to="/returns" className="block mt-4 group" data-testid="returns-teaser-link">
        <h2
          className="text-bone measure transition-colors duration-150 group-hover:!text-[#C69A4E]"
          style={{ fontSize: "clamp(24px, 3vw, 34px)", lineHeight: 1.15, letterSpacing: "-0.01em", maxWidth: "26ch" }}>
          Early money made 100x to 4,000x on paper. Late money is making 1x to 3x.
        </h2>
      </Link>
      <p className="t-small text-muted-s mt-4 measure">
        What the first priced round investors in today's AI leaders marked up, against what capital entering at
        scale has earned since. See the full sample returns brief.
      </p>
      <Link to="/returns" className="btn-ghost inline-block mt-6" data-testid="returns-teaser-button">View sample returns</Link>
    </section>
  );
}
